import { Button, Form, Input, Modal } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { useState } from "react";
import { BACKEND_PASSWORD_ERROR, PASSWORD_MESSAGE, PASSWORD_RULE } from "helpers/password";

interface Props {
  open: boolean;
  setOpen: (arg0: boolean) => void;
  userId: number;
}

const ChangePassword: React.FC<Props> = ({ open, setOpen, userId }) => {
  const [newPasswordForm] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const updatePassword = () => {
    setLoading(true);
    axios
      .post(`/students/${userId}/change-password/`, newPasswordForm.getFieldsValue())
      .then(() => {
        message("success", "Passordet ditt er oppdatert");
        setOpen(false);
      })
      .catch(response => {
        const errorData = response.response?.data || {};
        let messageSent = false;

        Object.entries(errorData).forEach(([key, value]) => {
          if (messageSent) return;
          const errorMessage = (value as string[][0]) || "";

          if (key === "new_password" && errorMessage.includes(BACKEND_PASSWORD_ERROR)) {
            messageSent = true;
            return message("error", PASSWORD_MESSAGE);
          }
          if (errorMessage.includes("This field may not be null.")) {
            messageSent = true;
            return message("error", "Fyll ut alle feltene");
          }
          if (errorMessage.includes("Current password is incorrect.")) {
            messageSent = true;
            return message("error", "Nåværende passord er feil");
          }
          if (errorMessage.includes("New password and confirm password do not match.")) {
            messageSent = true;
            return message("error", '"Nytt passord" og "Bekreft nytt passord" samsvarer ikke');
          }
        });
        if (!messageSent) return message("error", "Kunne ikke oppdatere passord");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal open={open} onCancel={() => setOpen(false)} title="Endre passord" footer={null}>
      <Form form={newPasswordForm} layout="vertical" onFinish={updatePassword} requiredMark={false}>
        <Form.Item
          label="Nåværende passord"
          name="current_password"
          initialValue={null}
          rules={[
            {
              required: true,
              message: "Vennligst skriv inn ditt nåværende passord",
            },
          ]}
        >
          <Input.Password placeholder="Skriv inn nåværende passord for å bekrefte at det er deg" />
        </Form.Item>
        <Form.Item
          label="Nytt passord"
          name="new_password"
          initialValue={null}
          rules={[
            {
              required: true,
              message: "Vennligst skriv inn ditt nye passord",
            },
            PASSWORD_RULE,
          ]}
        >
          <Input.Password placeholder="Skriv inn ditt nye passord" />
        </Form.Item>
        <Form.Item
          label="Bekreft nytt passord"
          name="confirm_password"
          initialValue={null}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("De to passordene samsvarer ikke"));
              },
            }),
            {
              required: true,
              message: "Vennligst bekreft ditt nye passord",
            },
          ]}
        >
          <Input.Password placeholder="Skriv inn ditt nye passord på nytt" />
        </Form.Item>
        <Form.Item>
          <Button loading={loading} type="primary" htmlType="submit" style={{ width: "100%" }}>
            Bekreft endring av passord
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
